var map = {
	"./back_name.png": "4bd3",
	"./circulo.svg": "d799",
	"./fondo.png": "8333",
	"./gox.png": "83f1",
	"./gox2.png": "ed23",
	"./gox3.png": "0d20",
	"./program.png": "d866",
	"./team.png": "cae9",
	"./team/team_1.png": "4dc8",
	"./team/team_2.png": "85a6",
	"./team/team_3.png": "27fa",
	"./team2.png": "3135"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ca0";